// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button ion-icon {
  color: var(--ion-color-dark);
}

ion-bottom-drawer ion-header {
  --background: red;
}
ion-bottom-drawer.drawer-up-position {
  transform: translateY(750px) !important;
}
ion-bottom-drawer ion-content {
  --padding-bottom: 160px;
}

:host-context(.android-14) ion-bottom-drawer.drawer-up-position {
  transform: translateY(570px) !important;
  top: 0 !important;
}

:host-context(.ios) ion-bottom-drawer.drawer-up-position {
  transform: translateY(650px) !important;
  top: 0 !important;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  @supports not (-webkit-touch-callout: none) {
    ion-bottom-drawer.drawer-up-position {
      transform: none !important;
      top: calc(100% - 210px) !important;
    }
  }
}
#map {
  height: 100%;
  width: 100%;
  overflow: visible !important;
}

.custom-toolbar ion-header ion-toolbar:first-of-type {
  padding-top: inherit;
}
.custom-toolbar ion-title {
  font-size: 16px !important;
}

.content-parent {
  --overflow: hidden;
}

ion-footer {
  z-index: 9999;
  background-color: #f6f6ff !important;
}

content-drawer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f6f6ff;
}
content-drawer ion-content {
  flex: 1;
  padding-top: 50px;
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
}

.margin-bottom-250 {
  margin-bottom: 290px !important;
}

.header-border {
  position: static !important;
  margin-bottom: 5px !important;
}

.drawer-margin {
  margin-top: -12px !important;
  position: absolute;
  top: 0px;
}

.drawer-margin-after {
  position: absolute;
  bottom: 13px;
  transform: translateY(110px) !important;
}

.drawer-footer {
  margin-top: -12px !important;
  position: absolute !important;
  bottom: 0px !important;
}

.positionOfDownloadIcon {
  position: relative;
  left: 8px !important;
}

.forWebDrawerCss {
  position: absolute !important;
  bottom: 218px !important;
}

.drawer-bottom {
  position: absolute !important;
  bottom: 160px !important;
}

.margin-bottom-edto-open {
  margin-bottom: 480px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/route-plan.page.scss"],"names":[],"mappings":"AACE;EACE,4BAAA;AAAJ;;AAKE;EACE,iBAAA;AAFJ;AAKE;EACE,uCAAA;AAHJ;AAKE;EACE,uBAAA;AAHJ;;AAMA;EACE,uCAAA;EACA,iBAAA;AAHF;;AAKA;EACE,uCAAA;EACA,iBAAA;AAFF;;AAIA;EACE;IACE;MACE,0BAAA;MACA,kCAAA;IADF;EACF;AACF;AAIA;EACE,YAAA;EACA,WAAA;EACA,4BAAA;AAFF;;AAME;EACE,oBAAA;AAHJ;AAKE;EACE,0BAAA;AAHJ;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,oCAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AAJF;AAME;EACE,OAAA;EACA,iBAAA;EACA,yDAAA;AAJJ;;AAQA;EACE,+BAAA;AALF;;AAOA;EACE,2BAAA;EACA,6BAAA;AAJF;;AAOA;EACE,4BAAA;EACA,kBAAA;EACA,QAAA;AAJF;;AAMA;EAEE,kBAAA;EACA,YAAA;EACA,uCAAA;AAJF;;AAMA;EACE,4BAAA;EACA,6BAAA;EACA,sBAAA;AAHF;;AAKA;EACE,kBAAA;EACA,oBAAA;AAFF;;AAIA;EACE,6BAAA;EACA,wBAAA;AADF;;AAGA;EACE,6BAAA;EACA,wBAAA;AAAF;;AAEA;EACE,+BAAA;AACF","sourcesContent":["ion-button {\n  ion-icon {\n    color: var(--ion-color-dark);\n  }\n}\n\nion-bottom-drawer {\n  ion-header {\n    --background: red;\n  }\n\n  &.drawer-up-position {\n    transform: translateY(750px) !important;\n  }\n  ion-content {\n    --padding-bottom: 160px;\n  }\n}\n:host-context(.android-14) ion-bottom-drawer.drawer-up-position {\n  transform: translateY(570px) !important;\n  top: 0 !important;\n}\n:host-context(.ios) ion-bottom-drawer.drawer-up-position {\n  transform: translateY(650px) !important;\n  top: 0 !important;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  @supports not (-webkit-touch-callout: none) {\n    ion-bottom-drawer.drawer-up-position {\n      transform: none !important;\n      top: calc(100% - 210px) !important;\n    }\n  }\n}\n\n#map {\n  height: 100%;\n  width: 100%;\n  overflow: visible !important;\n}\n\n.custom-toolbar {\n  ion-header ion-toolbar:first-of-type {\n    padding-top: inherit;\n  }\n  ion-title {\n    font-size: 16px !important;\n  }\n}\n\n.content-parent {\n  --overflow: hidden;\n}\n\nion-footer {\n  z-index: 9999;\n  background-color: #f6f6ff !important;\n}\n\ncontent-drawer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;          \n  background-color: #f6f6ff;\n\n  ion-content {\n    flex: 1;                  \n    padding-top: 50px;\n    padding-bottom: calc(100px + env(safe-area-inset-bottom));\n  }\n}\n\n.margin-bottom-250 {\n  margin-bottom: 290px !important;\n}\n.header-border {\n  position: static !important;\n  margin-bottom: 5px !important;\n}\n\n.drawer-margin {\n  margin-top: -12px !important;\n  position: absolute;\n  top: 0px;\n}\n.drawer-margin-after {\n  // margin-top: -12px !important;\n  position: absolute;\n  bottom: 13px;\n  transform: translateY(110px) !important;\n}\n.drawer-footer {\n  margin-top: -12px !important;\n  position: absolute !important;\n  bottom: 0px !important;\n}\n.positionOfDownloadIcon {\n  position: relative;\n  left: 8px !important;\n}\n.forWebDrawerCss {\n  position: absolute !important;\n  bottom: 218px !important;\n}\n.drawer-bottom {\n  position: absolute !important;\n  bottom: 160px !important;\n}\n.margin-bottom-edto-open {\n  margin-bottom: 480px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
